import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/bcwin-prod/site_front/node_modules/.pnpm/next@14.2.4_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.83.0/node_modules/next/dist/client/link.js");
